import register             from '../../register';
import $                    from 'jquery';
import FormSequence         from '../classes/form-sequence';
import extend               from '../util/extend';
import utm                  from '../util/utm';
import d2c_eligible_address from '../steps/d2c_eligible-address/step';
import success              from '../steps/d2c_eligible-success/step';
import error                from '../steps/error/step';
import footerTemplate       from '../templates/components/footer.hbs';

export default register( 'd2c_eligible', () => {

  const sequence = new FormSequence({
    $el: $('.signup-container'),
    first: 'd2c_eligible_address',
    configs: {
      d2c_eligible_address: {
        step: d2c_eligible_address,
        title: 'My Address',
        next: null,
        footer: footerTemplate({ pii_waitlist: true })
      },
      error: {
        step: error,
        next: null
      },
      success: {
        step: success,
        title: 'Success',
        next: null
      }
    },
    submit() {
      const url   = '/waitlist';
      const place = window.preloaded_address;

      delete place.address;

      const data = extend(
        { gis_id: window.gis_id || null },
        this.store.getState(),
        place,
        utm(),
        { flow: 'd2c_eligible' }
      );

      const btn = this.$el.find( this.submitSelector );

      btn.addClass('loading');

      $.ajax({
        method: 'POST',
        url,
        contentType: 'application/json',
        data: JSON.stringify( data ),
        success: user => {
          if ( window.acumen ) {
            window.acumen.identify({ email: user.email });
          }

          sequence.onSuccess( user );
        },
        complete: () => {
          btn.removeClass('loading');
        },
        error: () => {
          sequence.showStep('error');

          const $submit = sequence.$el.find('.sequence-submit');
          $submit.addClass('hidden');
        }
      });
    },
    onSuccess() {
      sequence.showStep('success');
      sequence.$el.find('.sequence-prev').hide();

      const $submit = sequence.$el.find('.sequence-submit');

      $submit.off();
      $submit.text('Done');

      $submit.on( 'click', ( ev ) => {
        ev.stopPropagation();
        window.location = 'https://starry.com/internet';
      });
    }
  });

  window.sequence = sequence;

});
